<app-header [pendinginvitationlist]="inboxCount"></app-header>
<app-leftsidebar></app-leftsidebar>

<div class="ntf-main">
  <div class="right-sec">
    <div class="ntf-wrap">

      <div class="ntf-head">
        <div class="ntf-head-text">
          <h1>Notifications</h1>
          <p>Game and map invites waiting on you, plus a short history of what you’ve already answered.</p>
        </div>
      </div>

      <section class="ntf-section" aria-labelledby="ntf-pending-heading">
        <div class="ntf-section-head">
          <h2 id="ntf-pending-heading">Needs a response</h2>
          <span class="ntf-count" [class.is-hot]="inboxCount > 0">{{ inboxCount }}</span>
        </div>

        <p class="ntf-empty" *ngIf="inboxCount === 0">You’re caught up — no pending invites.</p>

        <div class="ntf-list" *ngIf="inboxCount > 0">
          <article class="ntf-row" *ngFor="let item of pendingGames">
            <div class="ntf-thumb">
              <img [src]="gameImg(item)" alt="" />
            </div>
            <div class="ntf-body">
              <div class="ntf-title-row">
                <h3>{{ item.gamename || 'Untitled game' }}</h3>
                <span class="ntf-type">Game</span>
              </div>
              <p class="ntf-meta">
                {{ item.game_master_display_name || 'Unknown GM' }}
                <ng-container *ngIf="item.datetime"> · {{ item.datetime | date:'MMM d, y' }}</ng-container>
                <ng-container *ngIf="item.partyLevel"> · party lvl {{ item.partyLevel }}</ng-container>
                <ng-container *ngIf="item.averageLevel"> · avg {{ item.averageLevel }}</ng-container>
              </p>
            </div>
            <div class="ntf-actions">
              <button
                type="button"
                class="btn btn-green"
                [disabled]="isAccepting(item.id)"
                (click)="navigateToInvitationDetail(item.id)"
              >
                {{ isAccepting(item.id) ? 'Accepting…' : 'Accept' }}
              </button>
              <button type="button" class="btn btn-outline" (click)="declineInvitation(item)">
                Decline
              </button>
            </div>
          </article>

          <article class="ntf-row" *ngFor="let item of pendingMaps">
            <div class="ntf-thumb">
              <img [src]="mapImg(item)" alt="" />
            </div>
            <div class="ntf-body">
              <div class="ntf-title-row">
                <h3>{{ item.map_name || 'Untitled map' }}</h3>
                <span class="ntf-type ntf-type--map">Map</span>
              </div>
              <p class="ntf-meta">
                Invited{{ item.invited_by ? ' by user ' + item.invited_by : '' }}
                <ng-container *ngIf="item.invited_at"> · {{ item.invited_at | date:'MMM d, y' }}</ng-container>
              </p>
            </div>
            <div class="ntf-actions">
              <button
                type="button"
                class="btn btn-green"
                (click)="invitationAcceptRejectForMap(item.invitation_id, 'ACCEPTED')"
              >
                Accept
              </button>
              <button
                type="button"
                class="btn btn-outline"
                (click)="invitationAcceptRejectForMap(item.invitation_id, 'REJECTED')"
              >
                Decline
              </button>
            </div>
          </article>
        </div>
      </section>

      <section class="ntf-section" aria-labelledby="ntf-history-heading">
        <div class="ntf-section-head">
          <h2 id="ntf-history-heading">History</h2>
          <span class="ntf-count">{{ historyCount }}</span>
        </div>

        <p class="ntf-empty" *ngIf="historyCount === 0">No answered invites yet.</p>

        <div class="ntf-list" *ngIf="historyCount > 0">
          <article class="ntf-row ntf-row--history" *ngFor="let item of previousGames">
            <div class="ntf-thumb">
              <img [src]="gameImg(item)" alt="" />
            </div>
            <div class="ntf-body">
              <div class="ntf-title-row">
                <h3>{{ item.gamename || 'Untitled game' }}</h3>
                <span class="ntf-status" [attr.data-status]="statusKey(item.status)">{{ statusLabel(item.status) }}</span>
              </div>
              <p class="ntf-meta">
                {{ item.game_master_display_name || 'Unknown GM' }}
                <ng-container *ngIf="item.datetime"> · {{ item.datetime | date:'MMM d, y' }}</ng-container>
              </p>
            </div>
          </article>
        </div>
      </section>

    </div>
  </div>
</div>
